<template>
  <div class="align-start justify-center d-flex flex-column pb-4">
    <div v-if="showDate && !xs"
         class="d-flex">
      <div class="grey--text op-text-xl">{{ mx_getDutyDate(duty) }}</div>

    </div>
    <div v-else-if="showDate && xs"
         class="d-flex">
      <div class="op-text-m grey--text">{{ mx_getDutyDate(duty) }}</div>
    </div>

    <div class="op-text-xl font-weight-bold" >{{ $t('myDuty.title') }} {{ duty.dutyname }}</div>
  </div>
</template>

<script>
import dutyMixin from '../common/dutyMixin';
import commonMixin from '@/mixins/common';

export default {
  name: 'DutyCardTitle',
  mixins: [commonMixin, dutyMixin],
  props: {
    duty: Object,
    showDate: { type: Boolean, default: false },
  },
};
</script>
